<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">設定預計回任退休人員</h3>
        </div>
        <div class="modal-body">
          <table class="segment-table table datatable table-striped table-bordered">
            <thead>
              <tr>
                <th width="60px">
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                      @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                      type="checkbox"
                      name="check0-all"
                      id="check0-all"
                      value="1"
                      v-model="checkAll"
                    />
                    <label for="check0-all"></label>
                  </div>
                </th>
                <th width="130px">生效日期</th>
                <th width="130px">職級</th>
                <th width="130px">姓名</th>
                <th width="130px">狀態</th>
              </tr>
            </thead>
            <tbody v-if="this.ceclcList && this.ceclcList.length > 0">
              <tr v-for="(d, did) in ceclcList" :key="`td-${did}`">
                <td width="60px">
                  <div class="mr-0 checkbox checkbox-inline">
                    <input
                      @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                      type="checkbox"
                      name="`td-item[]`"
                      :id="`check0-${did}`"
                      :value="d"
                      v-model="selectedList"
                      @change="$emit('update', selectedList)"
                    />
                    <label :for="`check0-${did}`"></label>
                  </div>
                </td>
                <td width="130px">{{ d.retire_day }}</td>
                <td width="130px">{{ d.cepsnnm }}</td>
                <td width="130px">{{ d.ceclcnm }}</td>
                <td width="130px">{{ d.is_back == 'Y' ? '預計回任' : d.is_back == 'N' ? '已回任/確定退休' : '尚未設定'}}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="empty">
                  <h3 class="text-center py-5">無資料</h3>
                </td>
                <td v-show="false"></td>
                <td v-show="false"></td>
                <td v-show="false"></td>
                <td v-show="false"></td>
                <td v-show="false"></td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <span>狀態設定為「預計回任」者，該同仁的服務件將不會出現在調撥功能的地圖或列表中。</span>
          </div>
          <br />
          <div class="row">
            <div class="col-12 text-right">
              <a @click="$emit('submit', 'Y', selectedList)" class="btn btn-primary">預計回任</a>
              <a @click="$emit('submit', 'N', selectedList)" class="btn btn-primary">已回任/確定退休</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CecleModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    ceclcList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    open: function() {
      this.updateList();
    },    
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selectedList = [];
          this.ceclcList.forEach(data => {
            this.selectedList.push(data);
          });
        } else {
          //取消全選
          this.selectedList = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selectedList.length == this.ceclcList.length;
      }
      this.$emit("update", this.selectedList);
    }
  },
  data() {
    return {
      checkAll: false,
      clickTarget: "",
      remoteDataMsg: "資料讀取中，請稍候...",
      selectedList: []
    };
  },
  methods: {
    updateList() {
      this.checkAll = false;
      this.selectedList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.segment-table thead tr,
.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>